exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-84376cbe] .body{max-height:600px;overflow-y:scroll}\n", ""]);

